import React from 'react';
import { EditRedistributionData } from './editRedistributionLib';
import EditRedistributionRoute from './EditRedistributionRoute/EditRedistributionRoute';
import EditRedistributionProduct from './EditRedistributionProduct/EditRedistributionProduct';
import EditRedistributionPickingPosition from './EditRedistributionPickingPosition/EditRedistributionPickingPosition';
import EditRedistributionSourceStore from './EditRedistributionSourceStore/EditRedistributionSourceStore';
import EditRedistributionTargetStore from './EditRedistributionTargetStore/EditRedistributionTargetStore';
import EditRedistributionPickingPositions from './EditRedistributionPickingPositions/EditRedistributionPickingPositions';

type EditRedistributionProps = EditRedistributionData;

const EditRedistribution: React.FC<EditRedistributionProps> = ({
  calculationId,
  routes,
  sourceStores,
  targetStores,
  productId,
  pickingPosition,
  pickingPositions,
  useDepartments,
}) => {
  if (routes) {
    return (
      <EditRedistributionRoute
        calculationId={calculationId}
        routes={routes}
        useDepartments={useDepartments}
      />
    );
  }

  if (sourceStores) {
    return (
      <EditRedistributionSourceStore
        calculationId={calculationId}
        sourceStores={sourceStores}
        useDepartments={useDepartments}
      />
    );
  }

  if (targetStores) {
    return (
      <EditRedistributionTargetStore
        calculationId={calculationId}
        targetStores={targetStores}
        useDepartments={useDepartments}
      />
    );
  }

  if (productId) {
    return <EditRedistributionProduct calculationId={calculationId} productId={productId} />;
  }

  if (pickingPosition) {
    return (
      <EditRedistributionPickingPosition
        calculationId={calculationId}
        pickingPosition={pickingPosition}
      />
    );
  }

  if (pickingPositions) {
    return (
      <EditRedistributionPickingPositions
        calculationId={calculationId}
        pickingPositions={pickingPositions}
      />
    );
  }

  return <>Wrong parameters.</>;
};

export default EditRedistribution;
